import { Component, input, output } from '@angular/core';
import { NgxFileDropEntry, NgxFileDropModule } from 'ngx-file-drop';
import { SvgIconsComponent } from '../svg-icons/svg-icons.component';

@Component({
  selector: 'file-drop',
  imports: [NgxFileDropModule, SvgIconsComponent],
  templateUrl: './file-drop.component.html',
  styles: ``
})
export class FileDropComponent {
  fileAcceptedFormat = input.required<string>();
  titleMsg = input<string>('Upload Files');
  disabled = input<boolean>(false);
  useDragEnter = input<boolean>(true);
  buttonText = input<string>('Drag and Drop to');

  onFileDrop = output<NgxFileDropEntry[]>();
}
